import { useQuery } from '@tanstack/react-query';
import { ExternalLink } from 'lucide-react';
import { api } from '@/lib/api';
import { fmtRelative } from '@/lib/format';

type Props = { ticker: string };

export function NewsList({ ticker }: Props) {
  const q = useQuery({
    queryKey: ['news', ticker],
    queryFn: () => api.news(ticker),
    staleTime: 5 * 60_000,
  });

  return (
    <div className="rounded-xl border border-zinc-800 bg-zinc-950 p-3">
      <h3 className="text-sm font-medium text-zinc-200 mb-2">News</h3>
      {!q.data ? (
        <div className="text-xs text-zinc-400 py-6 text-center">Loading…</div>
      ) : q.data.items.length === 0 ? (
        <div className="text-xs text-zinc-400 py-6 text-center">No headlines yet.</div>
      ) : (
        <ul className="space-y-2">
          {q.data.items.slice(0, 8).map((n) => (
            <li key={n.id} className="text-xs">
              <a
                href={n.url}
                target="_blank"
                rel="noreferrer"
                className="flex items-start gap-2 group"
              >
                <ExternalLink className="size-3 text-zinc-400 mt-0.5 shrink-0 group-hover:text-zinc-400" />
                <div className="min-w-0">
                  <div className="text-zinc-200 group-hover:text-zinc-100 text-pretty leading-snug">
                    {n.headline}
                  </div>
                  <div className="text-[10px] text-zinc-400 mt-0.5">
                    {n.source} · {fmtRelative(n.publishedAt)}
                  </div>
                </div>
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
